import { useEffect, useState } from "react";
import HomeAPI from "../../api/homeApi";
import { InfinitySpin } from "react-loader-spinner"; // استيراد اللودر
import logo from "../../assets/logo.png"; // استيراد اللوجو

import HeaderCard from "./Components/HeaderCard/HeaderCard";
import ImagesCard from "./Components/ImagesCard/ImagesCard";
import CardsBooks from "./Components/WhyCardsBooks/CardsBooks";
import CardsCollections from "./Components/CardsCollections/CardsCollections";
import ExploreCountries from "./Components/ExploreCountries/ExploreCountries";
import CustomersReviews from "./Components/CustomersReviews/CustomersReviews";
import BannerHome from "./Components/BannerHome/BannerHome";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import SliderHeader from "Pages/BiographyPage/Components/SliderHeader/SliderHeader";
import ImagesCardSlide from "./Components/ImagesCardSlide/ImagesCardSlide";
import AboutNews from "./Components/AboutNews/AboutNews";
import ContactInformations from "./Components/ContactInformations/ContactInformations";
import Serviceinforamtion from "./Components/Serviceinforamtion/Serviceinforamtion";
const Home = () => {
  const [homeData, setHomeData] = useState(null);
  const [serviceData, setServiceData] = useState(null);
  const [BrandeData, setBrandData] = useState(null);
  // const [CategoryeData, setCategoryData] = useState(null);
  // const [CounrtyeData, setCounrtyData] = useState(null);
  // const [CertificateeData, setCertificateData] = useState(null);
  const [SettingData, setSettingData] = useState(null);
  const [NewsData, setNewsData] = useState(null);
  const [loading, setLoading] = useState(true); // حالة التحميل

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await HomeAPI.getHomeData();
        const dataService = await HomeAPI.getOurServicesData();
        const dataBrand = await HomeAPI.getBrandData();
        const dataCategory = await HomeAPI.getCategoryData();
        const dataCounrty = await HomeAPI.getCounrtyData();
        // const dataCertificate = await HomeAPI.getCertificateData();
        const dataSetting = await HomeAPI.getSettingData();
        const dataNews = await HomeAPI.getNewsData();

        setHomeData(data);
        setServiceData(dataService);
        setBrandData(dataBrand);
        // setCategoryData(dataCategory);
        // setCounrtyData(dataCounrty);
        // setCertificateData(dataCertificate);
        setSettingData(dataSetting);
        setNewsData(dataNews);
      } catch (error) {
        console.error("Error fetching home data:", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!loading) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [loading]);

  return (
    <>
      <HelmetInfo titlePage={"الصفحة الرئيسية"} />

      {loading ? (
        <div className="flex flex-col justify-center items-center h-screen">
          <img src={logo} alt="Logo" className="w-[20%] mb-4" /> {/* اللوجو */}
          <InfinitySpin
            // @ts-ignore
            visible={true}
            width="100"
            color="#0d6b70"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      ) : (
        <>
          <header className="mt-[85px]">
            <SliderHeader homeData={homeData} />
          </header>
          <HeaderCard homeData={homeData} />
          <ExploreCountries BrandeData={BrandeData} homeData={homeData}/>
          
          
          {/* <ImagesCard homeData={homeData} serviceData={serviceData} /> */}
          <Serviceinforamtion homeData={homeData} serviceData={serviceData}/>
          {/* <CardsBooks homeData={homeData} /> */}
          {/* <CardsCollections homeData={homeData} /> */}
          {/* <ImagesCardSlide homeData={homeData} CategoryeData={CategoryeData} /> */}
          {/* <BannerHome CounrtyeDatas={CounrtyeData} homeData={homeData} /> */}
          {/* <CustomersReviews homeData={homeData} CertificateeData={CertificateeData} /> */}
          <AboutNews homeData={homeData} NewsData={NewsData} />
          <ContactInformations homeData={homeData} SettingData={SettingData} />
        </>
      )}
    </>
  );
};

export default Home;
